<ng-container *ngIf="item">
    <ng-container [ngSwitch]="layout">
        <ng-container *ngSwitchCase="'carousel'">
            <ng-container *ngTemplateOutlet="carousel_template; context: { item: item }" ></ng-container>
        </ng-container> 
        <ng-container *ngSwitchCase="'list'">
            <ng-container *ngTemplateOutlet="list_item_template, context: { item: item }"></ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'card'">
            <ng-container *ngTemplateOutlet="card_item_template, context: { item: item }"></ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="list_item_template, context: { item: item }"></ng-container>
        </ng-container>
    </ng-container>
    
</ng-container>

<ng-template #carousel_template let-item="item">
    <div class="product-related-item theme-{{ layout }}">
        <div class="item__bg" [ngStyle]="{'background-image':'linear-gradient(45deg, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.5)),url(' + item.image + ')'}"></div>
        <div class="item__content container">
            <h5 class="text-secondary">Scelti per te</h5>
            <div class="text-warning h4"><b>Obiettivo:</b> {{ item.suggestion?.title }}</div>
            <div class="text-warning mb--24"><b>Descrizione:</b> {{ item.suggestion?.description }}</div>
            <h1 class="item__title text-white">{{item.name}}</h1>
            <h3 class="item__title text-white">{{item.description}}</h3>
            <button mat-stroked-button color="white">Scopri di più</button>
        </div>
    </div>
</ng-template>

<ng-template #list_item_template let-item="item">
    <!-- mostriamo il prodotto con orientamento a item list -->eccomi
</ng-template>

<ng-template #card_item_template let-item="item">
    <!-- mostriamo il prodotto con orientamento a card di griglia -->

    <mat-card class="example-card">
        <mat-card-header>
          <div mat-card-avatar class="example-header-image"></div>
          <mat-card-title>Shiba Inu</mat-card-title>
          <mat-card-subtitle>Dog Breed</mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image [ngSrc]="item.image" alt="Photo of a Shiba Inu">
        <mat-card-content>
          <p>
            The Shiba Inu is the smallest of the six original and distinct spitz breeds of dog from Japan.
            A small, agile dog that copes very well with mountainous terrain, the Shiba Inu was originally
            bred for hunting.
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions>
      </mat-card>
      
    card
</ng-template>
